import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import arrowDown from '../../../assets/icons/arrowDown.svg';
import { FormControlStyled, MenuItemStyled } from './styles';
import Select from '@mui/material/Select';

export const Dropdown = ({
  data,
  label,
  value,
  handleChange
}: {
  label: string;
  data: number[] | { label: string; value: number; range?: string }[];
  value: number;
  handleChange: (e: any) => void;
}) => {
  return (
    <Box sx={{ width: '100%', margin: 0 }}>
      <FormControlStyled fullWidth>
        <Select
          displayEmpty
          renderValue={(value: any) => {
            if (!value) {
              return <div style={{ color: '#d9d9d6' }}>{label}</div>;
            }
            const val = (data as any[]).find((key) => key.value === value);
            return val ? val.label : value;
          }}
          IconComponent={useCallback(
            (props) => (
              <img src={arrowDown} {...props} alt="arrowDown" />
            ),
            [arrowDown]
          )}
          value={value}
          labelId="select-options"
          inputProps={{
            'data-testid': `dropdown-${label.toLocaleLowerCase()}`
          }}
          name={label.toLowerCase()}
          onChange={handleChange}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 350 // Set the maximum height for the dropdown
              }
            }
          }}
        >
          <MenuItemStyled value="" disabled>
            {label}
          </MenuItemStyled>
          {data?.map((val) => {
            return (
              <MenuItemStyled value={val.value || val} key={val.value || val}>
                {val.label || val}
              </MenuItemStyled>
            );
          })}
        </Select>
      </FormControlStyled>
    </Box>
  );
};
